// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"740":"1472addc","957":"a11f582d"}[chunkId] + ".chunk.js";
};